namespace khi.bk117.view.parts
{
	import Debugger = com.enirva.debug.Debugger;
	import EventDispatcher = com.enirva.event.EventDispatcher;

	/*
	 * ページアップボタンの制御
	 */
	export class PageUpButton extends EventDispatcher
	{
		private pos:JQuery;
		private btn:JQuery;

		private status:number;

		private contactPos:JQuery;
		private contactBtn:JQuery;

		private contactStatus:number;

		constructor()
		{
			super();

			this.status = -1;
			this.btn = $(".pageUp");
			this.pos = $(".pageUpPos");

			this.btn.on("click", ()=>
			{
				$('body, html').stop(false, false).animate({ scrollTop: 0 }, 500);
        return false;
			});
			
			this.contactStatus = -1;
			this.contactBtn = $(".btnContact");
			this.contactPos = $(".btnContactPos");
		}


		public check(sc:number, h:number):void
		{
			if (sc < 100)
			{
				if (this.status != 0)
				{
					this.status = 0;
					//ボタン隠す
					
					$(document.body).removeClass("fixedPageUp");
					$(document.body).addClass("hidePageUp");
				}
				//Debugger.text(0, "隠す");
			}
			else if ((sc + h - 80) > this.pos.offset().top)
			{
				if (this.status != 1)
				{
					//下にFix
					this.status = 1;

					$(document.body).removeClass("fixedPageUp");
					$(document.body).removeClass("hidePageUp");
				}
				/*
				Debugger.text(0, this.pos.offset().top);
				Debugger.text(1, sc);
				Debugger.text(2, h);
				*/
			}
			else
			{
				if (this.status != 2)
				{
					//画面にFix
					this.status = 2;

					$(document.body).addClass("fixedPageUp");
					$(document.body).removeClass("hidePageUp");
				}
				/*
				Debugger.text(0, this.pos.offset().top);
				Debugger.text(1, this.btn.offset().top);
				Debugger.text(2, (sc + h));
				*/
			}

			if ((sc + h - 80) > this.contactPos.offset().top)
			{
				if (this.contactStatus != 1)
				{
					//下にFix
					this.contactStatus = 1;

					$(document.body).removeClass("fixedBtnContact");
				}
				//Debugger.text(0, this.contactPos.offset().top);
				//Debugger.text(1, sc);
				//Debugger.text(2, h);
			}
			else
			{
				if (this.contactStatus != 2)
				{
					//画面にFix
					this.contactStatus = 2;

					$(document.body).addClass("fixedBtnContact");
				}
				//Debugger.text(0, this.contactPos.offset().top);
				//Debugger.text(1, this.contactBtn.offset().top);
				//Debugger.text(2, (sc + h));
			}
		}
	}
}

